/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetClass,
  AssetInfo,
  AssetPage,
  AssetReplacement,
  BondCreateRequest,
  EnrichedAssetPage,
  EquityCreateRequest,
  Filter,
  FuturesCreateRequest,
  HTTPValidationError,
  OptionsCreateRequest,
} from '../models/index';
import {
    AssetClassFromJSON,
    AssetClassToJSON,
    AssetInfoFromJSON,
    AssetInfoToJSON,
    AssetPageFromJSON,
    AssetPageToJSON,
    AssetReplacementFromJSON,
    AssetReplacementToJSON,
    BondCreateRequestFromJSON,
    BondCreateRequestToJSON,
    EnrichedAssetPageFromJSON,
    EnrichedAssetPageToJSON,
    EquityCreateRequestFromJSON,
    EquityCreateRequestToJSON,
    FilterFromJSON,
    FilterToJSON,
    FuturesCreateRequestFromJSON,
    FuturesCreateRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    OptionsCreateRequestFromJSON,
    OptionsCreateRequestToJSON,
} from '../models/index';

export interface GetAssetRequest {
    pageIndex: number;
    pageSize: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface GetAssetReplacementsRequest {
    requestBody: Set<string>;
}

export interface GetAssetsBySIdRequest {
    requestBody: Set<string>;
}

export interface GetAssetsByScIdRequest {
    requestBody: Set<string>;
}

export interface GetEnrichedAssetRequest {
    pageIndex: number;
    pageSize: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface SaveNewBondRequest {
    bondCreateRequest: BondCreateRequest;
}

export interface SaveNewEquityRequest {
    equityCreateRequest: EquityCreateRequest;
}

export interface SaveNewFuturesRequest {
    futuresCreateRequest: FuturesCreateRequest;
}

export interface SaveNewOptionsRequest {
    optionsCreateRequest: OptionsCreateRequest;
}

export interface SearchAssetsRequest {
    searchTerm: string;
    limit?: number;
    assetClass?: AssetClass;
}

/**
 * 
 */
export class AssetApi extends runtime.BaseAPI {

    /**
     * Retrieve assets with the specified filters.
     */
    async getAssetRaw(requestParameters: GetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetPage>> {
        if (requestParameters.pageIndex === null || requestParameters.pageIndex === undefined) {
            throw new runtime.RequiredError('pageIndex','Required parameter requestParameters.pageIndex was null or undefined when calling getAsset.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling getAsset.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetPageFromJSON(jsonValue));
    }

    /**
     * Retrieve assets with the specified filters.
     */
    async getAsset(requestParameters: GetAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetPage> {
        const response = await this.getAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * For each sc_id, retrieve securities in its ETF replacement group, ordered by rank.
     */
    async getAssetReplacementsRaw(requestParameters: GetAssetReplacementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<AssetReplacement>; }>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling getAssetReplacements.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset/replacements`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * For each sc_id, retrieve securities in its ETF replacement group, ordered by rank.
     */
    async getAssetReplacements(requestParameters: GetAssetReplacementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<AssetReplacement>; }> {
        const response = await this.getAssetReplacementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Assets By S Id
     */
    async getAssetsBySIdRaw(requestParameters: GetAssetsBySIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInfo>>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling getAssetsBySId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset/batch/s-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInfoFromJSON));
    }

    /**
     * Get Assets By S Id
     */
    async getAssetsBySId(requestParameters: GetAssetsBySIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInfo>> {
        const response = await this.getAssetsBySIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Assets By Sc Id
     */
    async getAssetsByScIdRaw(requestParameters: GetAssetsByScIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInfo>>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling getAssetsByScId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset/batch/sc-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInfoFromJSON));
    }

    /**
     * Get Assets By Sc Id
     */
    async getAssetsByScId(requestParameters: GetAssetsByScIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInfo>> {
        const response = await this.getAssetsByScIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve assets and their last hold date with the specified filters.
     */
    async getEnrichedAssetRaw(requestParameters: GetEnrichedAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnrichedAssetPage>> {
        if (requestParameters.pageIndex === null || requestParameters.pageIndex === undefined) {
            throw new runtime.RequiredError('pageIndex','Required parameter requestParameters.pageIndex was null or undefined when calling getEnrichedAsset.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling getEnrichedAsset.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/enriched-asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnrichedAssetPageFromJSON(jsonValue));
    }

    /**
     * Retrieve assets and their last hold date with the specified filters.
     */
    async getEnrichedAsset(requestParameters: GetEnrichedAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnrichedAssetPage> {
        const response = await this.getEnrichedAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidate and update asset cache
     */
    async invalidateAssetCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset-cache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invalidate and update asset cache
     */
    async invalidateAssetCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.invalidateAssetCacheRaw(initOverrides);
        return await response.value();
    }

    /**
     * Save a new bond. Accepts and validates BondCreateRequest model.
     */
    async saveNewBondRaw(requestParameters: SaveNewBondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.bondCreateRequest === null || requestParameters.bondCreateRequest === undefined) {
            throw new runtime.RequiredError('bondCreateRequest','Required parameter requestParameters.bondCreateRequest was null or undefined when calling saveNewBond.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset/bond`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BondCreateRequestToJSON(requestParameters.bondCreateRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Save a new bond. Accepts and validates BondCreateRequest model.
     */
    async saveNewBond(requestParameters: SaveNewBondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.saveNewBondRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save a new equity. Accepts and validates EquityCreateRequest model.
     */
    async saveNewEquityRaw(requestParameters: SaveNewEquityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.equityCreateRequest === null || requestParameters.equityCreateRequest === undefined) {
            throw new runtime.RequiredError('equityCreateRequest','Required parameter requestParameters.equityCreateRequest was null or undefined when calling saveNewEquity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset/equity`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EquityCreateRequestToJSON(requestParameters.equityCreateRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Save a new equity. Accepts and validates EquityCreateRequest model.
     */
    async saveNewEquity(requestParameters: SaveNewEquityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.saveNewEquityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save a new Futures contract. Accepts and validates FuturesCreateRequest model.
     */
    async saveNewFuturesRaw(requestParameters: SaveNewFuturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.futuresCreateRequest === null || requestParameters.futuresCreateRequest === undefined) {
            throw new runtime.RequiredError('futuresCreateRequest','Required parameter requestParameters.futuresCreateRequest was null or undefined when calling saveNewFutures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset/futures`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FuturesCreateRequestToJSON(requestParameters.futuresCreateRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Save a new Futures contract. Accepts and validates FuturesCreateRequest model.
     */
    async saveNewFutures(requestParameters: SaveNewFuturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.saveNewFuturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save a new Options contract. Accepts and validates OptionsCreateRequest model.
     */
    async saveNewOptionsRaw(requestParameters: SaveNewOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.optionsCreateRequest === null || requestParameters.optionsCreateRequest === undefined) {
            throw new runtime.RequiredError('optionsCreateRequest','Required parameter requestParameters.optionsCreateRequest was null or undefined when calling saveNewOptions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset/options`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OptionsCreateRequestToJSON(requestParameters.optionsCreateRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Save a new Options contract. Accepts and validates OptionsCreateRequest model.
     */
    async saveNewOptions(requestParameters: SaveNewOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.saveNewOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for assets by symbol or description with optional asset class filtering
     */
    async searchAssetsRaw(requestParameters: SearchAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetInfo>>> {
        if (requestParameters.searchTerm === null || requestParameters.searchTerm === undefined) {
            throw new runtime.RequiredError('searchTerm','Required parameter requestParameters.searchTerm was null or undefined when calling searchAssets.');
        }

        const queryParameters: any = {};

        if (requestParameters.searchTerm !== undefined) {
            queryParameters['search_term'] = requestParameters.searchTerm;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.assetClass !== undefined) {
            queryParameters['asset_class'] = requestParameters.assetClass;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/asset/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetInfoFromJSON));
    }

    /**
     * Search for assets by symbol or description with optional asset class filtering
     */
    async searchAssets(requestParameters: SearchAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetInfo>> {
        const response = await this.searchAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
